import { connect } from "react-redux";
import { injectIntl } from "@ai360/core/intl";

import {
    getIsLoading,
    getCurrentFieldData,
} from "~/action-panel/components/import-module/components/import-wizard/selectors";
import { mapToolsActions, mapToolsSelectors } from "~/map";

import * as actions from "../../../actions";
import { AddEditFieldModal_, IAddEditFieldProps } from "../components/add-edit-field-modal";
import { getSystemAreaLimit } from "~/login";
import { getTheUserGuid, getTheUserLockCustomer } from "~/login/selectors";
import { initialFieldModel } from "~/action-panel/components/field-module";

const mapStateToProps = (state): Partial<IAddEditFieldProps> => ({
    currentFieldData: getCurrentFieldData(state),
    drawToolFlags: mapToolsSelectors.getDrawToolFlags(state),
    fieldEditGeometries: mapToolsSelectors.getFieldEditGeometries(state),
    fieldEditsChanged: mapToolsSelectors.getFieldEditsChanged(state),
    isLoading: getIsLoading(state),
    isLockCustomer: getTheUserLockCustomer(state),
    maximumArea: getSystemAreaLimit(state),
    userGuid: getTheUserGuid(state),
});

const mapDispatchToProps = (dispatch): Partial<IAddEditFieldProps> => ({
    fetchCurrentFieldData: (fieldGuid) => dispatch(actions.fetchCurrentFieldData(fieldGuid)),
    resetCurrentFieldData: () => dispatch(actions.setCurrentFieldData(initialFieldModel)),
    setIsLoading: (isLoading) => dispatch(actions.setIsLoading(isLoading)),
    setActiveToolset: (toolset, payload) =>
        dispatch(mapToolsActions.setActiveToolset(toolset, payload)),
    setActiveToolsetPayloadOnly: (payload) =>
        dispatch(mapToolsActions.setActiveToolsetPayloadOnly(payload)),
    setToolsetDisabled: (isDisabled) => dispatch(mapToolsActions.setToolsetDisabled(isDisabled)),
});

const mergeProps = (stateProps, dispatchProps, ownProps): Partial<IAddEditFieldProps> => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    isLockCustomer:
        ownProps.isLockCustomer !== undefined ? ownProps.isLockCustomer : stateProps.isLockCustomer,
});

export const AddEditFieldModal = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(injectIntl(AddEditFieldModal_));
